module.exports = __webpack_public_path__ + "fonts/Roboto-700-cyrillic-ext49.3004e52.woff2";